import React from "react";
import { useSelector } from "react-redux";
import { Route, Redirect } from "react-router-dom";

const ToolboxGuard = ({ children, ...rest }) => {
  const token = localStorage.getItem("token:data");

  const { profile } = useSelector((state) => state.users);

  let isToolboxAdminGuard = profile
  ? (profile && profile.role &&
      ((profile.role.map((role) => role.name).includes("admin")) || (profile.role.map((role) => role.name).includes("toolbox_admin")) || (profile.role.map((role) => role.name).includes("toolbox_viewer")))
    )
  : false;


    // ? (profile.role && profile.role.name === "toolbox_admin") || (profile.role && profile.role.name === "admin")

  return (
    <Route
      {...rest}
      render={({ location }) =>
        token && isToolboxAdminGuard ? (
          children
        ) : (
          <Redirect
            to={{
              pathname: "/dashboard",
              state: {
                from: location,
              },
            }}
          />
        )
      }
    />
  );
};

export default ToolboxGuard;
